module.exports = __webpack_public_path__ + "static/default-image-47c7d90e0329e261994907059149d398.jpg";